import { render } from "./PlayerInfo.vue?vue&type=template&id=955700c8"
import script from "./PlayerInfo.vue?vue&type=script&lang=js"
export * from "./PlayerInfo.vue?vue&type=script&lang=js"

import "./PlayerInfo.vue?vue&type=style&index=0&id=955700c8&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__